import React, { FunctionComponent } from 'react';
import { FitnessActivityIcon } from './FitnessActivityIcon';

import styles from './FitnessActivity.scss';
import { FitnessApplicationActivityType } from '../../../../types/__generated__';

interface Props {
  activityType: FitnessApplicationActivityType;
  title?: string;
}

export const FitnessActivity: FunctionComponent<Props> = ({
  activityType,
  title = '',
}) => {
  return (
    <p className={styles.activity}>
      <span className={styles.activityIcon}>
        <FitnessActivityIcon type={activityType} />
      </span>
      {title}
    </p>
  );
};
